export default "__VITE_ASSET__D10jhk6C__"